module.exports = __webpack_public_path__ + "img/45.tag_cleaner.213dda00.svg";